import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import Trending from './trending';
import MRECSidebar from './mrec-sidebar';
import { listTypes } from './similar-contributors-components/prop-types';
import SimilarContributors from './similar-contributors';
import SidebarContext from './sidebar-context';

const SSticky = styled(Sticky)`
  .sticky-inner-wrapper {
    z-index: 1;
  }
`;

export default function Sidebar(props) {
  /*
    We want to align with the top boundary of the left side wire-tools.
    The top position is being calculated as:
        .navbar height(152px)
      + .navbar's border width on the bottom(1px)
      + article.wire's top margin, which is 30px, referring to
        app/assets/stylesheets/components.wires.scss
      - MREC's top padding, which is 20px, referring to
        app/assets/stylesheets/components.mrec.scss
  */
  const showSimilarContributors = _.get(props, 'similarContributors.type')
    && _.get(props, 'similarContributors.list.length');

  return (
    <SidebarContext.Provider value={props}>
      <section className="sidebar">
        <Trending />
        <SSticky top={163} bottomBoundary="div[class^='content-container']">
          <MRECSidebar />
          {!!showSimilarContributors && <SimilarContributors {...props.similarContributors} />}
        </SSticky>
        <div className="sidebar-videos" />
      </section>
    </SidebarContext.Provider>
  );
}

Sidebar.propTypes = {
  ads: PropTypes.shape({
    path: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,
    targeting: PropTypes.shape({
      userid: PropTypes.number.isRequired,
      investorType: PropTypes.string,
      investorInterests: PropTypes.arrayOf(PropTypes.string),
      wireid: PropTypes.number,
      contributorid: PropTypes.number,
      category: PropTypes.string,
    }).isRequired,
  }).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  trending: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    profile: PropTypes.objectOf(PropTypes.object).isRequired,
    category: PropTypes.objectOf(PropTypes.object),
    series: PropTypes.objectOf(PropTypes.object),
    isSponsored: PropTypes.bool,
  })).isRequired,
  similarContributors: PropTypes.shape({
    type: PropTypes.string,
    list: listTypes,
  }).isRequired,
};
